export enum CellType {
  SOLID = 0,
  OPEN = 1
}

export interface Cell {
  type: CellType;
}

export interface DungeonConfig {
  width: number;
  height: number;
  cellSize: number;
}

export interface Vec3 {
  x: number;
  y: number;
  z: number;
}

export interface Vec2 {
  x: number;
  z: number;
}
